import axios from 'axios';

const ADMIN_URL = `${process.env.REACT_APP_API_URL}/api/admin/messaging`;

const getHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem('token')}`
});

export const getPlatformSummary = () =>
  axios.get(`${ADMIN_URL}/platform-summary`, { headers: getHeaders() });

export const purchaseCredits = (channel: string, amount: number, providerRef: string) =>
  axios.post(`${ADMIN_URL}/purchase`, { channel, amount, providerRef }, { headers: getHeaders() });

export const getAllSchoolWallets = () =>
  axios.get(`${ADMIN_URL}/school-wallets`, { headers: getHeaders() });

export const assignCredits = (schoolId: number, channel: string, amount: number) =>
  axios.post(`${ADMIN_URL}/assign`, { schoolId, channel, amount }, { headers: getHeaders() });

export const toggleServiceEnabled = (schoolId: number, channel: string, enabled: boolean) =>
  axios.put(`${ADMIN_URL}/service/${schoolId}`, { channel, enabled }, { headers: getHeaders() });

export const getSchoolTransactions = (schoolId: number, page = 0, size = 10) =>
  axios.get(`${ADMIN_URL}/transactions/${schoolId}`, {
    params: { page, size },
    headers: getHeaders()
  });

export const getPendingOrders = (page = 0, size = 10) =>
  axios.get(`${ADMIN_URL}/pending-orders`, {
    params: { page, size },
    headers: getHeaders()
  });

export const approveOrder = (orderId: number, creditAmount: number) =>
  axios.post(`${ADMIN_URL}/orders/${orderId}/approve`, { creditAmount }, { headers: getHeaders() });

export const rejectOrder = (orderId: number, reason: string) =>
  axios.post(`${ADMIN_URL}/orders/${orderId}/reject`, { reason }, { headers: getHeaders() });
